import { useId } from 'react';

import type { ResolvedHighlightArea } from '../../model/screencast-tooltips/types';

import styles from './ScreencastTooltip.module.scss';

// eslint-disable-next-line mobx/missing-observer
export const HighlightOverlay = ({
  imageNaturalWidth,
  imageNaturalHeight,
  areas,
}: {
  imageNaturalWidth: number;
  imageNaturalHeight: number;
  areas: ResolvedHighlightArea[];
}) => {
  const clipPathPrefix = useId().replace(/:/g, '');

  return (
    <svg
      className={styles.overlay}
      viewBox={`0 0 ${imageNaturalWidth} ${imageNaturalHeight}`}
      preserveAspectRatio="none"
    >
      <g opacity="var(--broadcast-highlight-fill-opacity)">
        {areas.map(({ area, clipRect }, index) => {
          const key = `highlight-${index}`;

          if (area.kind !== 'rect') {
            return null;
          }

          const rect = clipRect ?? area.rect;
          return (
            <rect
              key={key}
              x={rect[0]}
              y={rect[1]}
              width={rect[2] - rect[0]}
              height={rect[3] - rect[1]}
              fill="var(--broadcast-highlight-fill)"
            />
          );
        })}
      </g>
      <g opacity="var(--broadcast-highlight-line-opacity)">
        {areas.map(({ area, clipRect }, index) => {
          const key = `highlight-line-${index}`;
          const clipPathId = `broadcast-highlight-clip-${clipPathPrefix}-${index}`;

          if (area.kind !== 'polyline') {
            return null;
          }

          const points = area.points.map(([x, y]) => `${x},${y}`).join(' ');
          const polyline = (
            <polyline
              points={points}
              fill="none"
              strokeWidth={area.radius * 2}
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="var(--broadcast-highlight-fill)"
            />
          );

          if (!clipRect) {
            return <g key={key}>{polyline}</g>;
          }

          return (
            <g key={key}>
              <defs>
                <clipPath id={clipPathId}>
                  <rect
                    x={clipRect[0]}
                    y={clipRect[1]}
                    width={clipRect[2] - clipRect[0]}
                    height={clipRect[3] - clipRect[1]}
                  />
                </clipPath>
              </defs>
              <g clipPath={`url(#${clipPathId})`}>{polyline}</g>
            </g>
          );
        })}
      </g>
    </svg>
  );
};
